module.exports = __webpack_public_path__ + "img/1@2x.0ff39dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/1@2x.png
// module id = SGk9
// module chunks = 0